<template>
  <div class="check-item">
    <div class="row">
      <div class="col-sm-7">{{ i18n.rts }}</div>
      <div class="col-sm-3"></div>
      <div class="col-sm-2">
        <checker-status :result="result.value"></checker-status>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="servers">
          <div v-for="server in servers" class="server">
            <div class="row">
              <div class="col-xs-7">{{ server.name }}</div>
              <div class="col-xs-5">
                <checker-status :result="server.result"></checker-status>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import log from 'loglevel'
import io from 'socket.io-client'
import CheckerStatus from './CheckerStatus'

const checkerName = 'real-time-server-access'

export default {
  name: checkerName,
  data () {
    return {
      status: 'in-progress',
      result: {
        value: '',
        text: ''
      },
      i18n: window.SYSTEM_CHECK.i18n,
      servers: {},
      maxAttempts: 2
    }
  },
  computed: {
    failedServers () {
      var failures = []
      for (var name in this.servers) {
        var result = this.servers[name]
        if (result.result === 'failed') {
          failures.push(name)
        }
      }
      log.debug('Failed servers are ', failures)
      return failures
    }
  },
  components: {
    CheckerStatus
  },
  created () {
    this.$emit('initialized', {name: checkerName})
  },
  mounted () {
    var servers = window.SYSTEM_CHECK.realTimeServers
    servers.forEach((server) => {
      this.$set(this.servers, server.name, {name: server.name, status: 'in-progress'})
      this.connectServer(server)
    })
  },
  methods: {
    connectServer (server) {
      var clientTime = new Date().getTime()
      var socket = io(server.url, {query: {ping: true}})

      // Only consider the test passed when receive server's ping
      socket.on('ping', (res) => {
        var endTime = new Date().getTime()
        log.debug('RTS ' + server.url + ' pinged back.')
        this.$set(this.servers, server.name, {
          name: server.name,
          status: 'finished',
          result: 'passed',
          serverArriveTime: res.serverTime - clientTime,
          pingTime: endTime - clientTime
        })
        this.checkStatus()
        setTimeout(() => {
          socket.disconnect()
        }, 50)
      })

      // Consider the test failed when it cannot connect to the server
      // after the `maxAttempts`
      socket.on('reconnecting', (attempts) => {
        if (attempts > this.maxAttempts) {
          log.debug('RTS ' + server.url + ' max attempts reached.')
          socket.disconnect()
          this.$set(this.servers, server.name, {
            name: server.name,
            status: 'finished',
            result: 'failed'
          })
          this.checkStatus()
        }
      })

      /*
      socket.on('reconnect', (attempts) => {
        log.debug('RTS ' + server.url + ' reconnected after ' + attempts + ' attempts.')
      })
      socket.on('disconnect', () => {
        log.debug('RTS ' + server.url + ' disconnected.')
      })
      socket.on('connect_error', (error) => {
        log.debug('RTS ' + server.url + ' connect failed.', JSON.stringify(error))
      })
      socket.on('connect_timeout', () => {
        log.debug('RTS ' + server.url + ' connect timeout.')
      })
      */
    },
    checkStatus () {
      // Check if all checking has finished
      var allFinished = true
      var hasFailure = false
      for (var name in this.servers) {
        var result = this.servers[name]
        if (result.status !== 'finished') {
          allFinished = false
        }
        if (result.result === 'failed') {
          hasFailure = true
        }
      }

      log.debug('RTS all finished? ' + allFinished + '. Has failure? ' + hasFailure)

      if (allFinished) {
        this.result.value = hasFailure ? 'failed' : 'passed'
        var resultSummary = hasFailure ? 'Failed servers: ' + this.failedServers.join(', ') : 'passed'
        this.$emit('completed', {name: checkerName, result: resultSummary})
      }
    }
  }
}
</script>

<style scoped>
.servers {
  margin-top: 5px;
  margin-bottom: 8px;
  padding: 5px 0;
  border-radius: 3px;
}
.server {
  padding-left: 2px;
  line-height: 30px;
  border-bottom: 1px dashed #eee;
}
</style>
